/**
 * When the plant store counts its model as loading (lib/plant/plant-store.tsx). Kept in its own file so the store's
 * file exports components only (react-refresh).
 */

/**
 * Whether the plant model is still loading: before the first read, and through the one commit where the read has its
 * data but the nodes are not yet set from it (hydrated). A failed read is not loading. Pure.
 */
export function modelLoading(q: { isLoading: boolean; isSuccess: boolean }, hydrated: boolean): boolean {
  return q.isLoading || (q.isSuccess && !hydrated);
}
